// Pure math helpers shared by every gesture-driven surface
// (currently just the bottom sheet). Kept dependency-free so
// they're trivially testable.

/**
 * Compresses an overshoot past a boundary so a drag still moves
 * 1:1 near the edge but asymptotically resists further travel —
 * the "rubber band" feel used when dragging the sheet past its
 * resting position.
 */
export function rubberband(overshoot: number, dimension: number, constant = 0.55): number {
  return (overshoot * dimension * constant) / (dimension + constant * Math.abs(overshoot));
}

/**
 * Projects where a flick will land given its release velocity,
 * so a fast swipe can dismiss the sheet even if the finger only
 * traveled a short distance.
 */
export function project(velocity: number, decel = 0.998): number {
  return ((velocity / 1000) * decel) / (1 - decel);
}
